import Vue from "vue"
import Vuex from "vuex"
import auth from "./modules/auth"
import publications from "./modules/publications"
import snackbar from "./modules/snackbar"
import dialog from "./modules/dialog"
import application from "./modules/application"
import loading from "./modules/loading"
import createPersistedState from "vuex-persistedstate"
import SecureLS from "secure-ls"

Vue.use(Vuex)

const ls = new SecureLS({ isCompression: false })

export default new Vuex.Store({
  modules: {
    auth,
    application,
    publications,
    snackbar,
    dialog,
    loading,
  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: key => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: key => ls.remove(key),
      },
      key: "office",
      paths: ["auth", "application", "publications", "snackbar", "loading"],
    }),
  ],
})
